import classNames from "classnames/bind";
import React from "react";
import type { InvestigationRecencyBucketType } from "#src/routes/investigations/history/groupInvestigationsByRecency";
import { getInvestigationRecencyBucketLabel } from "#src/routes/investigations/history/investigationRecencyLabels";
import styles from "./InvestigationHistorySectionHeader.module.scss";

const cx = classNames.bind(styles);

type InvestigationHistorySectionHeaderProps = {
  bucket: InvestigationRecencyBucketType;
};

/**
 * Recency delimiter row for the investigation history virtualized list.
 */
export const InvestigationHistorySectionHeader = ({
  bucket,
}: InvestigationHistorySectionHeaderProps) => (
  <div
    className={cx("section-header")}
    role="presentation"
  >
    <span className={cx("section-header__label")}>
      {getInvestigationRecencyBucketLabel(bucket)}
    </span>
  </div>
);
